// Local-date helpers. The app works on YYYY-MM-DD strings (no timezone drift for
// "what day was this session").

export function todayISO(d = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function weekdayOf(dateISO: string): number {
  // 1 = Monday ... 7 = Sunday
  const d = new Date(dateISO + 'T00:00:00');
  return ((d.getDay() + 6) % 7) + 1;
}

const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatDate(dateISO: string): string {
  const d = new Date(dateISO + 'T00:00:00');
  return `${WEEKDAYS[(d.getDay() + 6) % 7]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

// Fine-grained "time ago" for timestamps (last sync), down to the minute. Takes a
// full ISO timestamp, not a date-only string.
export function timeAgoLabel(iso: string, now = new Date()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const secs = Math.max(0, Math.round((now.getTime() - then) / 1000));
  if (secs < 45) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  return `${Math.floor(days / 7)}w ago`;
}

export function daysAgoLabel(dateISO: string, now = new Date()): string {
  const then = new Date(dateISO + 'T00:00:00').getTime();
  const today = new Date(todayISO(now) + 'T00:00:00').getTime();
  const diff = Math.round((today - then) / 86400000);
  if (diff <= 0) return 'today';
  if (diff === 1) return 'yesterday';
  if (diff < 7) return `${diff}d ago`;
  if (diff < 14) return 'last week';
  return `${Math.floor(diff / 7)}w ago`;
}
